import { API_URL_EXECUTE_ENDPOINT } from "./apiMethods";
import axios, { AxiosResponse } from "axios";
import { getToken } from "./token";

export const execute = async <RequestType, ResponseType>(command: string, payload: RequestType) => {
    const result: AxiosResponse<ResponseType> = await axios.post(`${API_URL_EXECUTE_ENDPOINT}`, {
        ...payload,
        clientSyncId: generateClientSyncId(),
        method: command
    },{
        headers: {
            "AuthToken": getToken()
        },
        validateStatus: (status: number) => true
    });
    return result;
};

export const generateClientSyncId = () => Math.random().toString();
